import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { CustomerNote } from '../../models/customer-note';
import { GenericPaginated } from '../../models/generic-paginated';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerNotesService {

  private baseUrl = environment.url;

  private http = inject(HttpClient)
  private addParamsService = inject(AddParamsService)

  getCustomerNotesList = (customerId: string, params?: Params): Observable<GenericPaginated<CustomerNote>> => {
    return this.http.get<GenericPaginated<CustomerNote>>(`${this.baseUrl}/customers/${customerId}/notes`, {
      params: this.addParamsService.addParams(params)
    });
  }

  addCustomerNote = (customerID: number, payload: FormData): Observable<CustomerNote> => {
    return this.http.post<CustomerNote>(`${this.baseUrl}/customers/${customerID}/notes`, payload)
  }

  updateCustomerNote = (noteID: number, payload: object): Observable<CustomerNote> => {
    return this.http.patch<CustomerNote>(`${this.baseUrl}/customers/notes/${noteID}`, payload)
  }

  deleteCustomerNote = (noteID: number): Observable<CustomerNote> => {
    return this.http.delete<CustomerNote>(`${this.baseUrl}/customers/notes/${noteID}`)
  }
}
